module.exports = __webpack_public_path__ + "static/media/29DUNON16.1107d2ad.jpg";